// extracted by mini-css-extract-plugin
export default {"downloadIcon":"DownloadFloat_downloadIcon__np3Bh"};